import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installCustomAlert } from "./utils/customAlert";
import "./styles/customAlert.css";

installCustomAlert();
 
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for PWA functionality (only in production)
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: () => console.log('Service worker registered successfully'),
    onUpdate: (_registration) => {
      console.log('New content available. Update notification will be shown.');
      // Don't auto-reload - let PWAUpdateNotification component handle it
    }
  });
} else {
  // Unregister any existing service workers in development
  serviceWorkerRegistration.unregister();
} 